import { node, number, string } from "prop-types";

import styled, { useTheme } from "styled-components";
import { backgroundColor } from "theme";

import FnrTypography from "FnrTypography";

import { colorIsLight } from "Utilities/Colors/colorUtils";

const Amount = styled(FnrTypography)`
  padding: ${({ $paddingY }) => `${$paddingY}px`} 5px;
  border-radius: ${({ $borderRadius }) => $borderRadius}px;
  transition: background 300ms;
  ${backgroundColor}
`;

/**
 * @param {object} param0
 * @param {number} param0.amount
 * @param {boolean} param0.addPlusSign
 * @param {boolean} param0.showZero
 * @param {color} param0.color
 * @param {number} param0.borderRadius
 * @param {number} param0.paddingY
 * @returns
 */
const FnrBadge = ({
  color: colorArg = "textSecondaryDark",
  borderRadius = 6,
  paddingY = 1,
  children,
}) => {
  const { palette, colors } = useTheme();
  const color = palette[colorArg] || colors[colorArg] || colorArg;

  const textColor = colorIsLight(color) ? "textBlack" : "white";

  return (
    <Amount
      data-cy="FnrBadge_Container"
      $backgroundColor={color}
      fontSize="xs"
      bold
      color={textColor}
      $borderRadius={borderRadius}
      $paddingY={paddingY}
    >
      {children}
    </Amount>
  );
};

FnrBadge.propTypes = {
  color: string,
  children: node,
  borderRadius: number,
  paddingY: number,
};

export default FnrBadge;
